module.exports = __webpack_public_path__ + "media/images/contact_2-d59698371f001fbf187b0cd8b0456584.svg";